import templateManager from "./template-manager";

export default [
  ...templateManager,

  // service-meals
  "remove-templates",
  "delete-all-meals",
  "update-all-meals",
  "delete-all-categories",
  "update-all-categories",
  "delete-all-ingredients",
  "update-all-ingredients",

  // service-telegram-authorization
  "get-all-users",
  "get-all-users-balance",
  "continue-all-users-subscription",
  "get-all-users-transactions",
  "update-all-users-meta",
  "view-billing-all",
] as const;
